"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromSnakeToTitleCase = exports.fromCamelToTitleCase = exports.isDevMode = void 0;
function isDevMode() {
    return process.env.NODE_ENV == 'dev' || process.env.NODE_ENV == 'debug';
}
exports.isDevMode = isDevMode;
/**
 * Function to convert string in camel case to title case
 */
function fromCamelToTitleCase(camelCase) {
    if (camelCase == null)
        return camelCase;
    else if (camelCase === '')
        return '';
    let titleCase = camelCase[0].toUpperCase();
    for (let i = 1; i < camelCase.length; i++) {
        let ch = camelCase[i];
        if (ch.toLowerCase() === ch)
            titleCase += ch;
        else
            titleCase += ' ' + ch;
    }
    return titleCase;
}
exports.fromCamelToTitleCase = fromCamelToTitleCase;
/**
 * Function to convert string in upper or lower snake case to title case
 */
function fromSnakeToTitleCase(snakeCase) {
    if (snakeCase == null)
        return snakeCase;
    else if (snakeCase === '')
        return '';
    snakeCase = snakeCase.toUpperCase();
    let titleCase = snakeCase[0].toUpperCase();
    for (let i = 1; i < snakeCase.length; i++) {
        let ch = snakeCase[i];
        if (ch === '_' && snakeCase.length > i + 1) {
            titleCase += ' ' + snakeCase[i + 1];
            i++;
        }
        else
            titleCase += ch.toLowerCase();
    }
    return titleCase;
}
exports.fromSnakeToTitleCase = fromSnakeToTitleCase;
